
export class PhotoConcerne {

    id: string;
    photos_id: string;
    extranet: string;
    acl_resources_names_id: string;
    resource_id: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                     = data['id'] ? data['id'] : null;
        this.photos_id              = data['photos_id'] ? data['photos_id'] : null;
        this.extranet               = data['extranet'] ? data['extranet'] : null;
        this.acl_resources_names_id = data['acl_resources_names_id'] ? data['acl_resources_names_id'] : null;
        this.resource_id            = data['resource_id'] ? data['resource_id'] : null;
    }

}
